import React from 'react';
import ViolationCodeDetailSection from '../../../sections/AdminDashboard/Moderation/ViolationCodeDetail';

const AdminViolationCodeDetail = () => {
  return <ViolationCodeDetailSection />;
};

export default AdminViolationCodeDetail;

